import './polyfills';
// import '../modules/lazyload';
import './custom';
import './plugins';
import './slider';
import './funding';
import './background';
import './effects';
import './video';
import './modal';
import './modal--leadership';
import './popup';
import './accordion/accordion';

import './audiencemenu';

import './hashchange';

import './choices';

import './header';
